import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

export default function FormsValues(value) {
    const [dados, setDados] = useState();
    const locale = useSelector((state) => state.commonReducer.lang);
    const doc = useRef(document);
    const intl = useIntl();

    function translate(key) {
        return intl.formatMessage({ id: key });
    }

    useEffect(() => {
        function getPeriodos() {
            const periodos = [
                { value: 'hoje', label: translate('period.today') },
                { value: 'ontem', label: translate('period.yesterday') },
                { value: 'anteontem', label: translate('period.daybeforeyesterday') },
                { value: 'semana', label: translate('period.has1week') },
                { value: 'quinzena', label: translate('period.has15days') },
                { value: 'mes', label: translate('period.has1month') },
                { value: 'doisMeses', label: translate('period.has2months') },
                { value: 'tresMeses', label: translate('period.has3months') },
                { value: 'seisMeses', label: translate('period.has6months') },
                { value: 'ano', label: translate('period.has1year') },
                { value: 'outro', label: translate('period.other') },
            ];
            return periodos;
        }

        function getSLA() {
            const status = [
                { value: 'CONCLUIDOATRASADO', icon: 'pi pi-check-circle', label: translate('status.completedLate') },
                { value: 'ATRASADO', icon: 'pi pi-caret-down', label: translate('status.delayed') },
                { value: 'CONCLUIDO', icon: 'pi pi-check-circle', label: translate('status.SLAconcluded') },
                { value: 'NOPRAZO', icon: 'pi pi-caret-up', label: translate('status.onTime') },
                { value: 'CONCLUIDOSEMPREVISAO', icon: 'pi pi-spinner', label: translate('status.completedWithoutForecast') },
                { value: 'SEMPREVISAO', icon: 'pi pi-minus', label: translate('status.noForecast') },
            ];
            return status;
        }

        function getGeneros() {
            const generos = [
                { value: 'F', label: translate('gender.female') },
                { value: 'M', label: translate('gender.male') },
                { value: 'NI', label: translate('gender.undefined') },
            ];
            return generos;
        }

        function getDados() {
            let data;
            switch (value) {
                case 'periodos':
                case 'periodos_full':
                    data = getPeriodos();
                    break;
                case 'generos':
                    data = getGeneros();
                    break;
                case 'statusSLA':
                    data = getSLA();
                    break;
                default:
                    break;
            }
            return data;
        }
        if (doc.current.lang !== locale) {
            const _dados = getDados();
            setDados(_dados);
        }
    }, [locale, value]);

    return dados;
}



// WEBPACK FOOTER //
// ./src/constants/defaultForms.js